export default __webpack_public_path__ + "images/contact-hero.jpg";